export default "__VITE_ASSET__BPcNh2RY__"